export default {
  title: 'Żądania usunięcia danych',
  fields: {
    created_at: 'Zgłoszono o',
    restaurant: 'Restauracja',
    customer: 'Klient',
    note: 'Uwaga',
    status: 'Status',
    completed_by: 'Ukończono przez',
    actions: 'Akcje',
  },
  statuses: {
    pending: 'Oczekujące',
    completed: 'Ukończone',
  },
  buttons: {
    approve: 'Zatwierdź',
  },
  modals: {
    approve: {
      title: 'Zatwierdzić usunięcie danych dla {{name}}?',
      description:
        'Trwale usuwa dane osobowe klienta i nie można tego cofnąć. Żądanie zostanie oznaczone jako ukończone.',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_approve: 'Nie udało się zatwierdzić żądania',
    approved: 'Żądanie zatwierdzone i dane usunięte',
  },
};
